import React from 'react';
import type { AgentIconProps } from './AgentIconBase';

export default function ConciergeAgent({
  width = '100%',
  height = '100%',
  className = '',
}: AgentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      <path
        fill="#fff"
        d="M109.62,109.59c-.02,2.32-4.36,4.07-6.8,4.84-7.51,2.37-18.04,3.07-26.02,2.89-.77-.02-1.47.04-2.22.18-3.75-.06-7.41-.11-11.15-.44-4.22-.36-8.26-.95-12.42-1.7-2.18-.39-4.19-1.02-6.19-1.89-1.68-.73-4.24-2.26-4.45-3.88.09-2.38.29-4.62.66-6.96,1.13-5.73,3.61-10.49,8.61-13.67,3.79-2.4,7.83-4.13,12.18-5.34.26-.07.69.24.74.46.95,3.67,1.72,6.61,4.35,9.48,3.23,3.53,8.45,4.73,12.77,2.58,2.48-1.23,4.36-3.23,5.6-5.65,1.08-2.11,1.63-4.25,2.24-6.57.09-.32.79-.27,1.11-.17,5.28,1.71,11.32,4.05,15.15,8.07,2.08,2.18,3.5,4.72,4.36,7.6,1,3.32,1.5,6.67,1.46,10.16Z"
      />
      <path
        fill="#fff"
        d="M82.57,75.22c4.88.34,10.22-.17,13-4.39.15-.23-.02-.88-.11-1.15v-13.41c.63-.66.75-1.3.59-2.16-.89-4.71-3.09-9.07-6.79-12.22-6.77-5.76-16.45-6.78-24.38-2.81-5.82,2.92-9.7,8.36-10.8,14.76-.13.76-.22,1.38.49,1.98v13.66c-.13.38-.61,1.15-1,1.15h-3.01c-2.23,0-4.28-1.65-4.48-4.07s-.14-4.86-.02-7.3c.08-1.79,1.35-3.15,2.85-3.85.49-.23.78-.62.87-1.17,1.2-7.44,5.42-13.97,11.78-17.92,11.47-7.13,26.54-4.11,34.32,6.93,2.38,3.37,3.8,7.24,4.55,11.37.14.35.73.73,1.09.92,1.37.75,2.43,2.08,2.5,3.71.1,2.36.11,4.67,0,7.04-.11,2.24-1.9,3.92-3.99,4.36-.52.11-.8.42-1.03.86-1.11,2.17-2.83,3.94-4.98,5.09s-4.62,1.85-7.16,1.92l-4.55.13c-1.12.91-2.2,1.38-3.67,1.3-1.19-.06-2.49,0-3.61-.42-1.21-.46-1.8-1.66-1.74-2.87.05-1.12.87-2.36,2.11-2.69,1.61-.42,3.39-.52,5.01.02.73.24,1.47.86,2.17,1.2Z"
      />
      <path
        fill="#fff"
        d="M63.69,57.85l-3.18.14c-.26.01-.67.36-.67.64-.02,2.22-.15,4.3.04,6.48.27,3.19,1.28,6.15,2.84,8.89,1.72,3,4.12,5.24,7.16,6.82,4.86,2.54,10.06,1.03,15.43-.24-4.4,4.65-9.48,6.34-15.39,3.92-9.19-3.76-13.75-12.83-13.53-22.54.06-2.63.1-5.05.71-7.6.93-3.88,2.81-7.36,5.91-9.91s7.1-4.13,11.26-4.24c7.53-.2,14.64,3.41,17.51,10.47,2.09,5.15,2.79,14.2.91,19.22-.52,1.4-1.66,2.3-3.13,2.45l-1.74.17c2.7-4.21,2.87-8.87,2.48-13.77-.05-.83-.37-1.67-1.09-2.15-3.02-1.99-5.63-4.35-8.02-7.23-4.05,5.81-10.58,8.16-17.48,8.47Z"
      />
    </svg>
  );
}
